import React, {useEffect} from "react";
import StyledModal from "./Modal.styled";
import Button from "../Buttons/Button";

const Modal = (props) => {

    const closeOnEscapeKeyDown = e => {
        if ((e.charCode || e.keyCode) === 27) {
            props.onClose();
        }
    };

    useEffect(() => {
        document.body.addEventListener("keydown", closeOnEscapeKeyDown);
        return () => {
            document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
        };
    }, []);

    console.log(`in Modal show=${props.show}`);

    useEffect(() => {
        if (props.show)
            document.body.setAttribute("style", "overflow:hidden");
        return () => {
            document.body.removeAttribute("style");
        };
    }, [props.show]);


    return (
        <StyledModal>
            <div className={`fade ${props.show ? "modal-backdrop show" : ""} `}/>
            <div className={`modal fade ${props.show ? "show" : ""} `} onClick={props.onClose}>

                <div className="modal-dialog modal-lg modal-dialog-scrollable" onClick={e => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <h4 className="modal-title ">{props.title}</h4>
                            <button type="button" className="btn-close" onClick={props.onClose}/>
                        </div>
                        <div className="modal-body">{props.children}</div>
                        <div className="modal-footer bg-light">
                            {/*<button className="button btn btn-primary" onClick={props.onClose}>Close*/}
                            {/*</button>*/}
                            <Button className="btn btn-primary" onClick={props.onClose}>Close
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </StyledModal>
    );

};

export default Modal;